import { Component, Vue } from 'vue-property-decorator';
import TopDualLogo from '@/components/TopDualLogo/TopDualLogo'
import firebase from 'firebase';
import { request } from '@/tools/request.ts';
import { JwtHelper } from '@/tools/jwt.ts';
import { Guid } from "guid-typescript";
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<ParticipateOnline>({
  components: {
    TopDualLogo,
    LogoBar,
  },
})
export default class ParticipateOnline extends Vue {
  protected decoder = new JwtHelper();
  protected nonce: string = this.getNonce(10000000,99999999).toString();
  protected baseUrl: string = process.env.VUE_APP_API_BASE_ENDPOINT || 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/';
  protected validateUrl: string = this.baseUrl + 'elastos/authorizations?nonce='+this.nonce;
  protected qrcodeUrl: string = this.baseUrl + 'elastos/authorizations/qrcode?nonce='+this.nonce;
  protected email: string = '';
  protected password: string = '';
  protected dummyUser: DummyUser = {
    email: 'daan@archer.nl',
    password: 'secret',
  };
  protected loginError: boolean = false;
  protected firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTO_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECTID,
    storageBucket: '',
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
    measurementId: process.env.VUE_APP_MEASUREMENT_ID
  };
  protected elastosTimer = setInterval(this.elastosLogin, 5000);

  public mounted() {
    firebase.initializeApp(this.firebaseConfig);
  }

  public destroyed() {
    clearInterval(this.elastosTimer);
  }

  protected getNonce(min:number, max:number){
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  
  protected login() {
    if (this.email === this.dummyUser.email && this.password === this.dummyUser.password) this.$router.push('/register-song')
    else this.loginError = true;
  }
  
  protected elastosLogin() {
    this.loginError = false;
    request('get', this.validateUrl).then(
      (response: any) => {
        console.log('request response', response);
        if (response.status == 200) {
          clearInterval(this.elastosTimer);
          let token = response.data.token;
          let decoded = this.decoder.decode(token);
          this.$store.dispatch('setToken', token);
          this.$store.dispatch('setUser', decoded);
          this.$router.replace('/location-preferences');
        } else {
          this.loginError = true;
        }
      },
      (error: any) => {
        console.log('request error', error);
        this.loginError = true;
      }
    );
  }
  protected socialLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then((response: any) =>{
      this.$store.dispatch('setUser', response.additionalUserInfo.profile);
      this.$router.replace('/location-preferences');
    }).catch((err: any) => {
      alert('something went wrong..' + err.message);
    })
  }
}
interface DummyUser {
  email: string;
  password: string;
}
